<template>
  <div class="rule">
    <img src="../assets/img/rule-1.png" />
    <img src="../assets/img/rule-2.png" />
    <img src="../assets/img/rule-3.png" />
    <img src="../assets/img/rule-4.png" />
    <img src="../assets/img/rule-5.png" />
    <img src="../assets/img/rule-6.png" />
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.rule {
  padding-top: 0.88rem;
  background-color: #eee;
  img {
    width: 100%;
    margin-top: 0.2rem;
  }
}
</style>